/* Адаптер экрана активации (Activate.tsx) поверх реального API ядра. */
import { apiFetch, ApiError } from "../api/client";
export function makeActivateApi() {
    return {
        async activate({ token, password }) {
            try {
                await apiFetch("/api/auth/activate", {
                    method: "POST",
                    body: { token, password },
                });
            }
            catch (e) {
                if (e instanceof ApiError) {
                    switch (e.code) {
                        case "invalid_token":
                            return { status: "invalid_token" };
                        case "token_expired":
                            return { status: "token_expired" };
                        case "token_used":
                            return { status: "token_used" };
                        case "weak_password":
                            return { status: "weak_password" };
                        case "rate_limited":
                            return { status: "rate_limited" };
                    }
                }
                throw e;
            }
            return { status: "ok" };
        },
    };
}
